import src from "IMAGE";
export default { src, width: 277, height: 144, blurWidth: 0, blurHeight: 0};
